"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _uigSearch = _interopRequireDefault(require("@sfly/uig-search"));

var _search = _interopRequireDefault(require("@sfly/uig-svg-icon/action/search"));

var _close = _interopRequireDefault(require("@sfly/uig-svg-icon/action/close"));

var _constants = require("../constants");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var SearchBar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SearchBar, _React$Component);

  var _super = _createSuper2(SearchBar);

  function SearchBar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchBar);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchIconClick", function () {
      _this.setState({
        showSearchBox: true,
        resetSearch: false
      }, function () {
        _this.state.showSearchBox && _this.props.handleSearchIconClick && _this.props.handleSearchIconClick();

        if (_this.searchBoxRef && _this.searchBoxRef.current) {
          _this.searchBoxRef.current.focus();
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCloseIconClick", function () {
      var isKeyStrokeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        showSearchBox: false,
        resetSearch: true
      }, function () {
        !_this.state.showSearchBox && _this.props.handleCloseIconClick && _this.props.handleCloseIconClick();

        if (isKeyStrokeEvent && _this.singleSearchIconRef && _this.singleSearchIconRef.current) {
          _this.singleSearchIconRef.current.focus();
        }
      });
    });
    _this.state = {
      showSearchBox: false,
      resetSearch: false
    };
    _this.singleSearchIconRef = _react.default.createRef();
    _this.searchBoxRef = _react.default.createRef();
    _this.onWindowResize = _this.onWindowResize.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SearchBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener("resize", this.onWindowResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onWindowResize);
      }
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (typeof window !== 'undefined' && window.innerWidth < 1200 && this.state.resetSearch) {
        this.setState({
          resetSearch: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var brandType = this.props.brandType;
      return _react.default.createElement("div", {
        className: "uig-search-container brand-".concat(brandType, "  ").concat(this.state.showSearchBox ? 'showSearchBox' : 'hideSearchBox')
      }, !this.state.showSearchBox && _react.default.createElement("div", {
        className: "uig-single-srch-icon-container",
        onClick: this.handleSearchIconClick,
        tabIndex: "0",
        "aria-label": "Open Search Bar",
        role: "button",
        onKeyPress: function onKeyPress(event) {
          _Utils.default.handleKeyPress(event, function () {
            _this2.handleSearchIconClick();
          });
        },
        ref: this.singleSearchIconRef
      }, _react.default.createElement(_search.default, {
        className: 'uig-srch-icon'
      })), _react.default.createElement("div", {
        className: "".concat(this.state.showSearchBox ? 'uig-expanded-search-box-container' : 'uig-hide-expanded-search-box-container'),
        tabIndex: "-1",
        "aria-label": "Search Bar",
        role: "region",
        ref: this.searchBoxRef
      }, this.props.isCloseButtonNeeded && this.state.showSearchBox && _react.default.createElement("div", {
        className: "uig-single-close-icon-container",
        onClick: this.handleCloseIconClick,
        tabIndex: "0",
        "aria-label": "Close Search Bar",
        role: "button",
        onKeyDown: function onKeyDown(event) {
          _Utils.default.handleKeyPress(event, function () {
            _this2.handleCloseIconClick(true);
          }, [].concat((0, _toConsumableArray2.default)(_Utils.default.keyCodesToHandle), [_Utils.default.keyCodeMap.escape]));
        }
      }, _react.default.createElement(_close.default, {
        className: 'uig-close-icon'
      })), _react.default.createElement(_uigSearch.default, {
        reset: this.state.resetSearch,
        jwtToken: this.props.jwtToken,
        user: this.props.user,
        brandType: this.props.brandType,
        dataLinkName: _constants.SEARCH_BOX_SELECTED
      })));
    }
  }]);
  return SearchBar;
}(_react.default.Component);

exports.default = SearchBar;